import { z } from 'zod';
/**
 * R&L Carrier API - RateQuote:
 * https://technology.rlcarriers.com/api-documentation/rate-quote/
 */ export const ShippingCountryCodes = {
    USA: 'USA',
    CAN: 'CAN'
};
export const ShippingCountries = {
    [ShippingCountryCodes.USA]: 'United States',
    [ShippingCountryCodes.CAN]: 'Canada'
};
export const ShippingStatesUS = {
    AK: 'Alaska',
    AL: 'Alabama',
    AR: 'Arkansas',
    AS: 'American Samoa',
    AZ: 'Arizona',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DC: 'District of Columbia',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    GU: 'Guam',
    HI: 'Hawaii',
    IA: 'Iowa',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    MA: 'Massachusetts',
    MD: 'Maryland',
    ME: 'Maine',
    MI: 'Michigan',
    MN: 'Minnesota',
    MO: 'Missouri',
    MP: 'Northern Mariana Islands',
    MS: 'Mississippi',
    MT: 'Montana',
    NC: 'North Carolina',
    ND: 'North Dakota',
    NE: 'Nebraska',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NV: 'Nevada',
    NY: 'New York',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    PR: 'Puerto Rico',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TT: 'Trust Territories',
    TX: 'Texas',
    UT: 'Utah',
    VA: 'Virginia',
    VI: 'Virgin Islands',
    VT: 'Vermont',
    WA: 'Washington',
    WI: 'Wisconsin',
    WV: 'West Virginia',
    WY: 'Wyoming'
};
export const ShippingProvincesCA = {
    AB: 'Alberta',
    BC: 'British Columbia',
    MB: 'Manitoba',
    NB: 'New Brunswick',
    NL: 'Newfoundland and Labrador',
    NS: 'Nova Scotia',
    NT: 'Northwest Territories',
    NU: 'Nunavut',
    ON: 'Ontario',
    PE: 'Prince Edward Island',
    QC: 'Quebec',
    SK: 'Saskatchewan',
    YT: 'Yukon'
};
export var ShippingChargeType;
(function(ShippingChargeType) {
    ShippingChargeType["MinimumCharge"] = "MINIMUM";
    ShippingChargeType["DiscountSaved"] = "DISCNT";
    ShippingChargeType["DiscountedFreightCharge"] = "DISCNF";
    ShippingChargeType["FuelSurcharge"] = "FUEL";
    ShippingChargeType["LiftGateFee"] = "LIFT";
    ShippingChargeType["NotificationFee"] = "NOT";
    ShippingChargeType["NetCharge"] = "NET";
})(ShippingChargeType || (ShippingChargeType = {}));
export const ShippingApiResponseOk = 200;
const Address = z.object({
    CountryCode: z.enum(Object.keys(ShippingCountries)),
    StateOrProvince: z.enum([
        ...Object.keys(ShippingStatesUS),
        ...Object.keys(ShippingProvincesCA)
    ]).optional(),
    City: z.string().optional(),
    ZipOrPostalCode: z.string()
});
const ServiceCenter = z.object({
    Code: z.string(),
    Location: z.string(),
    ZipCode: z.string(),
    Phone: z.string(),
    Address1: z.string(),
    Address2: z.string().nullable()
});
const ShippingItem = z.object({
    // Possible Class values:
    // '50.0', '55.0', '60.0', '65.0', '70.0', '77.5', '85.0', '92.5', '100.0',
    // '110.0', '125.0', '150.0', '175.0', '200.0', '250.0', '300.0', '400.0', '500.0'
    Class: z.string(),
    Weight: z.number().positive()
});
export const RateQuoteRequest = z.object({
    RateQuote: z.object({
        Origin: Address,
        Destination: Address,
        Items: z.array(ShippingItem),
        DeclaredValue: z.number(),
        AdditionalServices: z.array(z.string())
    })
});
export const RateQuoteResponse = z.object({
    RateQuote: z.union([
        z.object({
            Origin: Address,
            Destination: Address,
            OriginServiceCenter: ServiceCenter,
            DestinationServiceCenter: ServiceCenter,
            CustomerDiscounts: z.string(),
            Charges: z.array(z.object({
                Type: z.string(),
                Title: z.string(),
                Weight: z.string(),
                Rate: z.string(),
                Amount: z.string()
            })),
            Ocean: z.unknown(),
            CategorizedMessages: z.object({
                GeneralMessages: z.array(z.string()),
                TransitMessages: z.array(z.string()),
                RatesMessages: z.array(z.string())
            }),
            ServiceLevels: z.array(z.object({
                Name: z.string(),
                Code: z.string(),
                QuoteNumber: z.string(),
                ServiceDays: z.number(),
                Charge: z.string(),
                NetCharge: z.string(),
                HourlyWindow: z.unknown()
            }))
        }),
        z.null()
    ]),
    Code: z.number(),
    Errors: z.array(z.object({
        Property: z.string(),
        ErrorMessage: z.string(),
        ExceptionMessage: z.string()
    })),
    Messages: z.array(z.string())
});

//# sourceMappingURL=shipping-api.types.js.map